import { FirestoreDataConverter } from '../node_modules/firebase/firestore/dist/firestore';

export default class Shop {
  constructor(
    readonly id?: string,
    readonly isActive?: boolean,
    readonly host?: string,
    readonly name?: string,
    readonly domain?: string,
    readonly scopes?: string[],
    readonly defaultEnvelopFrom?: string,
    readonly defaultHeaderFrom?: string,
    readonly subdomain?: string,
    readonly signature?: string,
    readonly forwardings?: string[],
    readonly headerFroms?: {},
    readonly isEnabledWebToTicket?: boolean,
    readonly webToTicketHash?: boolean,
    readonly webToTicketCallback?: boolean,
    readonly alreadyTrial?: boolean,
    readonly ownerId?: string
  ) {}
}


export const SHOP = 'shops';
export const shopConverter: FirestoreDataConverter<Shop> = {
  toFirestore(shop: Shop) {
    return {
      isActive: shop.isActive,
      host: shop.host,
      name: shop.name,
      domain: shop.domain,
      scopes: shop.scopes,
      defaultEnvelopFrom: shop.defaultEnvelopFrom,
      defaultHeaderFrom: shop.defaultHeaderFrom,
      subdomain: shop.subdomain,
      signature: shop.signature,
      forwardings: shop.forwardings,
      headerFroms: shop.headerFroms,
      isEnabledWebToTicket: shop.isEnabledWebToTicket,
      webToTicketHash: shop.webToTicketHash,
      webToTicketCallback: shop.webToTicketCallback,
      alreadyTrial: shop.alreadyTrial,
      ownerId: shop.ownerId
    }
  },

  fromFirestore(
      snapshot,
      options
  ): Shop {
    const data = snapshot.data(options)!;
    return new Shop(snapshot.id,
      data.isActive,
      data.host,
      data.name,
      data.domain,
      data.scopes,
      data.defaultEnvelopFrom,
      data.defaultHeaderFrom,
      data.subdomain,
      data.signature,
      data.forwardings,
      data.headerFroms,
      data.isEnabledWebToTicket,
      data.webToTicketHash,
      data.webToTicketCallback,
      data.alreadyTrial,
      data.ownerId
    );
  }
}